import { createApp } from 'vue';

import Enum from '@interface/_index';
import RE from '@module/regexp';
import Check from '@module/check';
import Config from '@constant/config';
import FN from '@constant/function';
import RQ from '@server/request';
import Store from '@model/_index';
import Application from '@constant/application';
import VueApplication from './application.vue';

import '@constant/style';

const globalExpand: any = { // 拓展变量
    $ENV,
    $Lodash,
    $Moment,
    $Numeral,
    $MathJS,
    $Enum: Enum, // 公共枚举
    $RegExp: RE, // 正则表达式
    $Check: Check, // 校验
    $Config: Config, // 配置
    $FN: FN, // 函数库
    $RQ: RQ, // 请求库
    $Store: Store, // 存储
    $Application: Application // 应用
  },
  app = createApp(VueApplication);

Object.keys(globalExpand).forEach((v: string) => { // 全局挂载
  const config = {
    enumerable: false,
    writable: false,
    configurable: false,
    value: globalExpand[v]
  };
  
  Object.defineProperty(global, v, config);
  Object.defineProperty(app.config.globalProperties, v, config);
});

Application.Main = app;
Application.Main
  .use(Application.Pinia)
  .use(Application.Router)
  .mount('body');